// O backend (DispatchRouteService) manda um AppError 409 com
// JSON.stringify({connectionOptions: [...]}) como mensagem quando o cliente
// tem conversa de verdade em mais de uma conexão (Escritório/Visita/
// Interior) e nenhuma foi escolhida ainda — extrai essa lista pra decidir se
// mostra o RouteConnectionPickerDialog, sem quebrar em nenhum outro tipo de
// erro (401, 500, validação etc.), que devem continuar caindo no toastError
// normal de sempre.
export const extractConnectionOptions = (err) => {
  if (Number(err?.response?.status) !== 409) {
    return null;
  }

  const rawMessage = err?.response?.data?.error;
  if (typeof rawMessage !== "string") {
    return null;
  }

  try {
    const parsed = JSON.parse(rawMessage);
    return Array.isArray(parsed?.connectionOptions) && parsed.connectionOptions.length > 0
      ? parsed.connectionOptions
      : null;
  } catch (parseError) {
    return null;
  }
};
